import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, "Edit Address", -1)
const _hoisted_2 = { class: "col-span-12 space-y-3" }
const _hoisted_3 = {
  key: 0,
  class: "flex border border-gray-200 rounded-2xl items-center p-4 h-[calc(100vh-140px)] justify-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs italic text-center" }, "No data yet", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "border-b border-solid border-gray-100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Address Type:")
], -1)
const _hoisted_9 = { class: "py-2" }
const _hoisted_10 = { class: "font-normal" }
const _hoisted_11 = { class: "border-b border-solid border-gray-100" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Address:")
], -1)
const _hoisted_13 = { class: "py-2" }
const _hoisted_14 = { class: "font-normal" }
const _hoisted_15 = { class: "border-b border-solid border-gray-100" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Barangay:")
], -1)
const _hoisted_17 = { class: "py-2" }
const _hoisted_18 = { class: "font-normal" }
const _hoisted_19 = { class: "border-b border-solid border-gray-100" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "City/Municipality/District:")
], -1)
const _hoisted_21 = { class: "py-2" }
const _hoisted_22 = { class: "font-normal" }
const _hoisted_23 = { class: "border-b border-solid border-gray-100" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Province:")
], -1)
const _hoisted_25 = { class: "py-2" }
const _hoisted_26 = { class: "font-normal" }
const _hoisted_27 = { class: "border-b border-solid border-gray-100" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Region:")
], -1)
const _hoisted_29 = { class: "py-2" }
const _hoisted_30 = { class: "font-normal" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Direction:")
], -1)
const _hoisted_32 = { class: "py-2" }
const _hoisted_33 = { class: "font-normal" }
const _hoisted_34 = { class: "absolute z-10 top-2 right-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#333333]" }, "Edit", -1)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#333333]" }, "Remove", -1)
const _hoisted_39 = { class: "flex justify-end col-span-12" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, "Add New", -1)
const _hoisted_41 = {
  key: 1,
  class: "col-span-12"
}

import IntakeLayout from '../../Component/IntakeLayout.vue';
import { ref, onMounted,computed } from 'vue';
import { EllipsisVerticalIcon } from "@heroicons/vue/24/outline";
import { PlusIcon } from "@heroicons/vue/24/solid";
import EditPage from './EditPage.vue';
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { useRouter, useRoute } from "vue-router";
import { Menu, MenuButton, MenuItems, MenuItem, } from "@headlessui/vue";
import PatientAddressService from "@/classes/Cases/PatientAddressService";
import pickBy from "lodash/pickBy";  
import { onIonViewWillEnter } from '@ionic/vue';  
import TrashIcon from "@/components/icons/trashIcon.vue";
import PencilBlackIcon from "@/components/icons/pencilBlackIcon.vue";

  /******************************* For Offline Imports************************************ */
  import { useNetworkStore } from "@/store/network";
 import Rules from "@/classes/Cases/CasePatientAddress/Offline/Validation/Rules";
 import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
 import useVuelidate from "@vuelidate/core"; 
 import CasePatientAddressForm from "@/classes/Cases/CasePatientAddress/Offline/Formatters/CasePatientAddressForm";
 import { PatientAddressCreate } from "@/classes/Cases/CasePatientAddress/Offline/Interface/CasePatientInterface";
 import CasePatientAddressService from "@/classes/Cases/CasePatientAddress/CasePatientAddressService";
 import OnlineSynching from '@/classes/Synching/OnlineSynching';
 
 
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const { createRules } = Rules;
 const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable); 
 /*************************************************************************************** */

const isShowNav = ref(true);
const showConfirmation = ref(false);
const showSuccess = ref(false);
const showSuccessSave = ref(false);
const router = useRouter();
const route = useRoute();
const hasContent = ref<boolean>(false);
const patient = ref<string>('');
const selectedItemId = ref<number | null>(null);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const offlineParams = ref<string>(route.query.offline); 
const items = ref<PatientAddressIndex[]>([]); 
const isIonWillEnter = ref<boolean>(false);
const onlineSync = new OnlineSynching();


const removeConfirmation = (item) => {
	showConfirmation.value = true;
	selectedItemId.value = item.id || item?.offlineData?.offline_id;
};

const deleteItem = () => {
	CasePatientAddressService.delete(
		patientId.value,
		caseId.value,
		selectedItemId.value,
		pickBy({ isOfflineData: offlineParams.value ? true : false }),
		isNetworkAvailable.value
	)
		.then(() => {
            items.value.data = items.value.data.filter((item: any) => item.id != selectedItemId.value);
			showSuccess.value = true;
			showConfirmation.value = false;
		})
		.catch((error: object) => console.log(error));
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
    if (isNetworkAvailable.value) {
        setTimeout(() => {
            window.location.reload();
        }, 300);
    }
};

const getData = async () => {
	const intake = ref(true);
	if (caseId.value) { 
		const response = await CasePatientAddressService.index(
			patientId.value,
			caseId.value,
			pickBy({ rows: 10 }),
			isNetworkAvailable.value
		);
 
 
		if (response?.status === 200 || response?.data != undefined) {
			items.value = response.data.items;
			hasContent.value = response.data.items.total > 0 ? true : false;
            patient.value = response.data.patient;
 
			if(!isNetworkAvailable.value){
				await retrieveGuardianOffline(response);
			}
		}
	}
};
  /**
 * Retrieve resource data
 */
 const retrieveGuardianOffline = async (response: object):any => { 
	hasContent.value = response.data.items.total > 0 ? true : false; 
	response.data.items = await Promise.all(response.data.items.data?.map(async (item: any) => {
        return  await CasePatientAddressForm.viewForm(item);
    }));
	console.log(response.data.items);
	items.value = { data: response.data.items };     
};
 
onIonViewWillEnter(async () => {
    if (isIonWillEnter.value) {	
        await getData();
        await onlineSync.checkDrafts();
    }
});
onMounted(async () => {
    await getData();
    await onlineSync.checkDrafts();
    isIonWillEnter.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IntakeLayout, {
    isShowNav: isShowNav.value,
    isWarningMessage: true,
    patient: patient.value
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (isShowNav.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              (!hasContent.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                : _createCommentVNode("", true),
              (hasContent.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(items.value.data, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "relative w-full p-4 pr-8 border border-gray-200 rounded-2xl",
                      key: index
                    }, [
                      _createElementVNode("table", _hoisted_6, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("td", _hoisted_9, [
                              _createElementVNode("p", _hoisted_10, _toDisplayString(item?.residence_type_meta?.description), 1)
                            ])
                          ]),
                          _createElementVNode("tr", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("td", _hoisted_13, [
                              _createElementVNode("p", _hoisted_14, _toDisplayString(item.address), 1)
                            ])
                          ]),
                          _createElementVNode("tr", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("td", _hoisted_17, [
                              _createElementVNode("p", _hoisted_18, _toDisplayString(item.barangay?.name), 1)
                            ])
                          ]),
                          _createElementVNode("tr", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("td", _hoisted_21, [
                              _createElementVNode("p", _hoisted_22, _toDisplayString(item.city?.name), 1)
                            ])
                          ]),
                          _createElementVNode("tr", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("td", _hoisted_25, [
                              _createElementVNode("p", _hoisted_26, _toDisplayString(item.province?.name), 1)
                            ])
                          ]),
                          _createElementVNode("tr", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("td", _hoisted_29, [
                              _createElementVNode("p", _hoisted_30, _toDisplayString(item.region?.name), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_31,
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("p", _hoisted_33, _toDisplayString(item.direction), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_unref(Menu), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(MenuButton), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(EllipsisVerticalIcon), { class: "w-5 h-5 cursor-pointer" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_Transition, {
                              "enter-active-class": "transition duration-100 ease-out",
                              "enter-from-class": "transform scale-95 opacity-0",
                              "enter-to-class": "transform scale-100 opacity-100",
                              "leave-active-class": "transition duration-75 ease-in",
                              "leave-from-class": "transform scale-100 opacity-100",
                              "leave-to-class": "transform scale-95 opacity-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(MenuItems), { class: "absolute right-2 w-[178px] rounded z-10 p-4 space-y-2 bg-white shadow-[0_2px_2px_0_rgba(0,0,0,.15)]" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(MenuItem), null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (
													_unref(router).replace(
														`/patient/${patientId.value}/cases/${caseId.value}/patient-addresses/${
															item.id ||
															item?.offlineData
																?.offline_id
														}/edit${
															offlineParams.value
																? '?offline=true'
																: ''
														}?intake=true`
													)
												),
                                          class: "flex items-center space-x-2.5 cursor-pointer"
                                        }, [
                                          _createVNode(PencilBlackIcon, { class: "w-6 h-6" }),
                                          _hoisted_36
                                        ], 8, _hoisted_35)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(MenuItem), null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          onClick: ($event: any) => (removeConfirmation(item)),
                                          class: "flex items-center space-x-2.5 cursor-pointer"
                                        }, [
                                          _createVNode(TrashIcon, { class: "object-contain w-6 h-6 cursor-pointer" }),
                                          _hoisted_38
                                        ], 8, _hoisted_37)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
						_unref(router).replace(
							`/patient/${patientId.value}/cases/${caseId.value}/patient-addresses/create${
								offlineParams.value ? '?offline=true' : ''
							}?intake=true`
						)
					)),
                class: "sm:w-auto w-full"
              }, [
                _createVNode(ButtonComponent, { customClass: "primary sm:w-auto w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PlusIcon), { class: "w-3.5 h-3.5" }),
                    _hoisted_40
                  ]),
                  _: 1
                })
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _createVNode(EditPage, {
              form: _ctx.form,
              optionAdressType: _ctx.optionAdressType,
              optionRegion: _ctx.optionRegion,
              optionProvince: _ctx.optionProvince,
              optionCityMunicipality: _ctx.optionCityMunicipality,
              optionBarangay: _ctx.optionBarangay	
            }, null, 8, ["form", "optionAdressType", "optionRegion", "optionProvince", "optionCityMunicipality", "optionBarangay"])
          ])),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (deleteItem())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Delete Record?",
        content: "Are you sure you wish to delete this record?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        noBtn: "",
        show: showSuccess.value,
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Record Deleted!",
        content: "Selected record has been successfully deleted."
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        noBtn: "",
        show: showSuccessSave.value,
        "action-text": "Close",
        title: "Record Save",
        content: "Intake has been updated"
      }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["isShowNav", "patient"]))
}
}

})